(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  /* Sync aria-expanded with details state */
  document.querySelectorAll('#gym-launch-faq details > summary').forEach(function(s) {
    s.addEventListener('click', function(e) {
      var d = this.parentElement;
      var expanded = d.hasAttribute('open');
      requestAnimationFrame(() => {
        this.setAttribute('aria-expanded', d.hasAttribute('open') ? 'true' : 'false');
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
